import { formatNumber } from '@dec/shared';
import { Card } from 'react-bootstrap';
import {
  Calendar3Week,
  CalendarEvent,
  CurrencyDollar,
  FileEarmarkText,
  FileSpreadsheet,
  Hourglass
} from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import env from '../../../../env';
import DateParser from '../../../../utils/date';
import { ViewItem } from '../../NonCompliance/components/ViewItem';
import { type OmissionsPaymentsByTax } from '../types';

export const TaxPaymentItem = ({ omission }: { omission: OmissionsPaymentsByTax }) => {
  const { t } = useTranslation();
  const periodLabel = t('non-compliances.label.period');
  //const periodSubLabel = '2022-01';

  const dueDateLabel = t('non-compliances.label.expirationDate');
  //  const dueDateSubLabel = '2022-01';

  const lastPaymentLabel = t('collections.label.lastPayment'); // t('non-compliances.label.NotificationDate');
  //const notificationDateSubLabel = '2022-01';

  const balanceLabel = t('taxpayer-current-account.label.balance');

  const waitLabel = t('non-compliances.label.wait');
  const daysLabel = t('non-compliances.label.days');

  const penaltyLabel = t('non-compliances.label.penalty');
  //const penaltySubLabel = '200.10';

  const amountLabel = t('non-compliances.label.declarationAmount');
  const amountPaymentLabel = t('non-compliances.label.paymentAmount');

  return (
    <>
      <h2>{omission.taxName}</h2>

      {omission.details.map((detail) => {
        return (
          <>
            <Card>
              <Card.Body>
                <Card.Text>
                  <div className="d-flex justify-content-between flex-wrap">
                    <ViewItem
                      title={periodLabel}
                      subTitle={detail.periodText}
                      icon={FileEarmarkText}
                    />
                    <ViewItem
                      title={dueDateLabel}
                      subTitle={DateParser.toString(detail.dueDate)}
                      icon={CalendarEvent}
                    />

                    <ViewItem
                      title={lastPaymentLabel}
                      link={
                        detail?.paymentId
                          ? `${env.appUrl}/reports/payments/check-load-records/${detail?.paymentId}`
                          : undefined
                      }
                      subTitle={DateParser.toString(detail.paymentDate as Date, '---')}
                      icon={Calendar3Week}
                    />
                    {/*<ViewItem*/}
                    {/*  link={*/}
                    {/*    detail?.taxreturnId*/}
                    {/*      ? `${env.appUrl}/reports/taxreturn/preview/${detail?.taxreturnId}`*/}
                    {/*      : undefined*/}
                    {/*  }*/}
                    {/*  title={presentationDateLabel}*/}
                    {/*  subTitle={DateParser.toString(detail.presentationDate, '---')}*/}
                    {/*  icon={CalendarCheck}*/}
                    {/*/>*/}

                    <ViewItem
                      title={waitLabel}
                      subTitle={detail.days ? `${detail.days} ${daysLabel}` : '---'}
                      icon={Hourglass}
                    />
                    <ViewItem
                      title={penaltyLabel}
                      subTitle={formatNumber(detail.penalty as number)}
                      icon={FileSpreadsheet}
                    />
                    <ViewItem
                      title={amountLabel}
                      subTitle={formatNumber(detail.amount as number)}
                      icon={CurrencyDollar}
                    />
                    <ViewItem
                      title={amountPaymentLabel}
                      subTitle={formatNumber(detail.amountPayment as number)}
                      icon={CurrencyDollar}
                    />
                    <ViewItem
                      title={balanceLabel}
                      subTitle={formatNumber(detail.difference as number)}
                      icon={CurrencyDollar}
                    />
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </>
        );
      })}
    </>
  );
};
